<template>
  <div class="inicio">
    <nav class="inicio__pestanas" aria-label="Secciones">
      <a class="inicio__pestana inicio__pestana--activa" href="/" aria-current="page">
        <i class="mdi mdi-map"></i> Mapa
      </a>
      <a class="inicio__pestana" href="/comando-5">
        <i class="mdi mdi-view-dashboard"></i> Comando 5
      </a>
    </nav>

    <div class="inicio__contenido">
      <command-map />
    </div>
  </div>
</template>

<script>
// Home provisorio: la pestaña Mapa es el tablero de siempre y Comando 5 es
// otra página, así que va como enlace y no como pestaña de Vue.
export default {
  name: 'HomePage',
};
</script>
